import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { FilterProps, SelectFilter } from './types';
import type { EnumCustomFieldSchema } from 'bundles/crm/types';

type Props = FilterProps<SelectFilter, EnumCustomFieldSchema>;

export default function CompCustomFieldSelectFilter({ filter, schema, onChange }: Props) {
  return (
    <ManagedFormGroup
      label={schema.label}
      type="select"
      value={filter}
      onValueChange={onChange}
    >
      <option/>
      <Options options={schema.enumOptions.map(value => ({ label: value, value }))} />
    </ManagedFormGroup>
  );
}
